import React, { memo } from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  CartesianGrid,
  Area,
} from "recharts";

/* Custom Tooltip */
const CustomTooltip = ({ active, payload, label }) => {
  if (!active || !payload || !payload.length) return null;

  return (
    <div
      style={{
        background: "#ffffff",
        borderRadius: 10,
        padding: "10px 14px",
        boxShadow: "0 10px 25px rgba(0,0,0,0.15)",
        border: "1px solid rgba(0,0,0,0.05)",
        minWidth: 140,
      }}
    >
      <div
        style={{
          fontSize: 13,
          fontWeight: 600,
          marginBottom: 6,
          color: "#374151",
        }}
      >
        {label}
      </div>

      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 8,
        }}
      >
        <span
          style={{
            width: 10,
            height: 10,
            borderRadius: "50%",
            backgroundColor: "#ec4b48",
            display: "inline-block",
          }}
        />
        <span style={{ fontSize: 13, color: "#111827" }}>
          {payload[0].value} <strong>kWh</strong>
        </span>
      </div>
    </div>
  );
};

const PeakLoadGraph = memo(function PeakLoadGraph({ data }) {
  if (!data || data.length === 0) return null;

  return (
    <ResponsiveContainer width="100%" height="100%" debounce={300}>
      <LineChart
        data={data}
        margin={{ top: 25, right: 35, left: 20, bottom: 45 }}
      >
        
        {/* Gradient */}
        <defs>
          <linearGradient id="energyGradient" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor="#ec4b48" stopOpacity={0.35} />
            <stop offset="100%" stopColor="#ec4b48" stopOpacity={0.05} />
          </linearGradient>
        </defs>

        {/* Grid */}
        <CartesianGrid
          strokeDasharray="3 3"
          stroke="rgba(0,0,0,0.08)"
        />

        {/* X Axis */}
        <XAxis
          dataKey="date"
          angle={-30}
          textAnchor="end"
          height={60}
          interval={0}
          tick={{ fontSize: 12, fill: "#374151" }}
          axisLine={{ stroke: "#9ca3af", strokeWidth: 1 }}
          tickLine={false}
          label={{
            position: "insideBottom",
            offset: -5,
            fill: "#374151",
            fontSize: 13,
            fontWeight: 600,
          }}
        />

        {/* Y Axis */}
        <YAxis
          tick={{ fontSize: 12, fill: "#374151" }}
          axisLine={{ stroke: "#9ca3af", strokeWidth: 1 }}
          tickLine={false}
          label={{
            value: "Energy (kWh)",
            angle: -90,
            position: "insideLeft",
            offset: -10,
            fill: "#374151",
            fontSize: 13,
            fontWeight: 600,
          }}
        />

        {/* Tooltip */}
        <Tooltip
          content={<CustomTooltip />}
          cursor={{
            stroke: "#ec4b48",
            strokeWidth: 1,
            strokeDasharray: "4 4",
          }}
        />

        {/* Area */}
        <Area
          type="monotone"
          dataKey="energy"
          stroke="none"
          fill="url(#energyGradient)"
          isAnimationActive={false}
        />

        {/* Line */}
        <Line
          type="monotone"
          dataKey="energy"
          stroke="#ec4b48"
          strokeWidth={2.5}
          dot={false}
          activeDot={{
            r: 5,
            stroke: "#ec4b48",
            strokeWidth: 2,
            fill: "#ffffff",
          }}
          isAnimationActive={false}
        />
      </LineChart>
    </ResponsiveContainer>
  );
});

export default PeakLoadGraph;
